import axios from 'axios'

const MODALIDAD_MAP = {
    'Permisos Forestales - Predio Privado': 'permiso_forestal_en_predio_privado',
    'Permisos Forestales - Comunidad Nativa': 'permiso_forestal_en_comunidad_nativa',
    'Concesión forestal maderable': 'concesión_forestal_maderable',
    'Autorizaciones Forestales - Bosques Secos': 'permiso_autorización_forestal_en_bosques_secos',
    'Concesiones Forestales - No Maderables Castaña': 'concesión_no_maderable_castaña',
}

function normalizeRecords(records) {
    return records.map(item => ({
        ...item,
        modalidad: MODALIDAD_MAP[item.modalidad] || item.modalidad,
    }))
}

export default {
    data() {
        return {
            dataset: [],
        }
    },
    methods:{
        async dataRegentes() {
    
            await axios
                .get(`/data/data_regentes.json`)
                .then(response => {                    
                    this.dataset = this.dataset.concat(normalizeRecords(response.data))                    
                })
        },
        async infoRegentes() {

            await axios
                .get(`/data/actualizado.json`)
                .then(response => {
                    this.dataset = this.dataset.concat(normalizeRecords(response.data))
                })
        }
    }
}
